import { permissionRoleLabels } from "utils/enums";

export const extractUniqueRoles = (listItems) =>
  Array.from(new Set(listItems.map((item) => item.role)));

export const generateTableColumns = (roles) => [
  {
    header: { id: 'facility', value: 'Facility', isSortable: true },
    dataKey: 'facility',
  },
  ...roles.map((role) => ({
    header: { id: role, value: permissionRoleLabels[role] ?? role, isSortable: true },
    dataKey: role,
  })),
];

export const transformFacilityRoleData = (facilities, roles) =>
  facilities.map((facility) => {
    const row = {
      id: facility.facilityId,
      facility: facility.facilityName,
    };

    roles.forEach((role) => {
      const match = facility.accessPermissionsPerRoles.find(
        (item) => item.role === role,
      );
      row[role] = match ? match.status : 'n/a';
      row[`permissionId_${role}`] = match?.id || null;
    });

    return row;
  });

export const getTableHeaders = (columns) =>
  columns.map((column) => column.header);

export const prepareTableData = (data, columns, renderCell) =>
  data
    ? data.map((item) => ({
        id: item.id,
        cells: columns.map(({ dataKey }) => {
          const rawValue = item[dataKey];
          return {
            value: renderCell ? renderCell(rawValue, dataKey, item) : rawValue,
          };
        }),
      }))
    : [];
